var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4243 3.57576C19.6586 3.8101 19.6586 4.19 19.4242 4.42429L7.42228 16.4243C7.30974 16.5368 7.15711 16.6 6.99797 16.6C6.83883 16.6 6.68621 16.5367 6.57371 16.4242L1.17566 11.0242C0.941387 10.7898 0.941456 10.4099 1.17581 10.1757C1.41017 9.94138 1.79007 9.94145 2.02434 10.1758L6.99816 15.1514L18.5758 3.5757C18.8101 3.3414 19.19 3.34143 19.4243 3.57576Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.07fb943133400c2924bb20b1f613b24e.svg";
export { ForwardRef as ReactComponent };